// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import 'lib-flexible/flexible'
import Mint from 'mint-ui';
import "mint-ui/lib/style.css"
import VueClipboard from 'vue-clipboard2'
import $ from 'jquery'
import './assets/css/common.css'
import './assets/css/index.css'
import Vant from 'vant';
import 'vant/lib/index.css';


Vue.use(VueClipboard)
Vue.use(VueCookies)
Vue.use(Mint)
Vue.use(Vant)
Vue.prototype.$http = axios
Vue.use($);

Vue.config.productionTip = false
VueClipboard.config.autoSetContainer = true

router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title
    next()
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js